import { NumberFormatOptions } from 'vue-i18n';

const integer: NumberFormatOptions = {
  style: 'decimal',
  maximumFractionDigits: 0,
};

const scorePercentage: NumberFormatOptions = {
  style: 'percent',
  maximumFractionDigits: 2,
};

const analyticsPercentage: NumberFormatOptions = {
  style: 'percent',
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
};

const analyticsTrend: NumberFormatOptions = {
  style: 'percent',
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
  // plusSign: true,
};

const analyticsInteger: NumberFormatOptions = {
  style: 'decimal',
  maximumFractionDigits: 0,
};

const analyticsFloat: NumberFormatOptions = {
  style: 'decimal',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

const metricTemperature: NumberFormatOptions = {
  style: 'decimal',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

const metricHumidity: NumberFormatOptions = {
  style: 'percent',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

const currency: NumberFormatOptions = {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'symbol',
};

const numberFormatters = {
  integer,
  scorePercentage,
  analyticsPercentage,
  analyticsInteger,
  analyticsFloat,
  analyticsTrend,
  metricTemperature,
  metricHumidity,
  currency,
};

export type NumberFormatter = keyof typeof numberFormatters;

export const numberFormats = {
  da: numberFormatters,
  de: numberFormatters,
  en: numberFormatters,
  'en-GB': numberFormatters,
  es: numberFormatters,
  fi: numberFormatters,
  fr: numberFormatters,
  it: numberFormatters,
  nl: numberFormatters,
  pl: numberFormatters,
  'pt-BR': numberFormatters,
  sv: numberFormatters,
  tr: numberFormatters,
  cs: numberFormatters,
  hu: numberFormatters,
  sk: numberFormatters,
  sr: numberFormatters,
  ro: numberFormatters,
  sl: numberFormatters,
  bg: numberFormatters,
  hr: numberFormatters,
  'zh-CN': numberFormatters,
};
